import React from 'react';

const CtaSection = () => {
  const handleSmoothScroll = (id, offset = 0) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div id="support">
      <div className="pt-10 px-5 pb-10 px-5 sm:px-6  lg:pt-[74px] lg:pb-[140px] w-full relative bg-[url('./support.png')] bg-no-repeat	bg-cover	">
        {/* <img
            src={supportImg}
            alt={supportImg}
            className=" w-full h-full object-cover transition-all duration-400 ease-ease-custom  group-hover:translate-y-[44px] group-hover:grayscale-[1]"
          /> */}

        <div className="max-w-7xl mx-auto w-full  m-auto text-center ">
          <span className="block font-cinzel  text-[24px] lg:text-[40px] font-bold text-white tracking-wide md:tracking-wider lg:mb-[80px]">
            Support US
          </span>
          <h2 className="font-cinzel uppercase text-[34px] sm:text-[78px] 2xl:text-[84px] leading-[120%] uppercase lg:capitalize font-bold font-cinzel lg:mb-6 my-5">
            Be a part of Transforming Hollywood
          </h2>
          <p className="font-ubuntu  lg:text-[32px] text-[22px]">
            Join a Powerful Movement, Reshaping Stories, Screens, and Futures
          </p>

          <div className="flex justify-center flex-col lg:flex-row items-center gap-4 lg:gap-[30px] mt-10 lg:mt-[100px]">
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleSmoothScroll('contact');
              }}
              className="group relative flex items-center font-ubuntu font-bold justify-center gap-[10px] lg:min-w-[306px] min-w-[200px] p-[4px]  lg:h-[88px] h-[60px] lg:text-[28px] text-[16px] text-black no-underline rounded-[50px] overflow-hidden backdrop-blur-[15px] bg-[#fff] transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)] border border-solid border-[#fff] hover:bg-[rgba(0,0,0,0.55)] hover:text-white"
            >
              Donate Now
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleSmoothScroll('contact');
              }}
              className="group relative flex items-center font-ubuntu font-bold justify-center gap-[10px]  lg:min-w-[306px] min-w-[200px] p-[4px]  lg:h-[88px] h-[60px] lg:text-[28px] text-[16px] text-white no-underline rounded-[50px] overflow-hidden backdrop-blur-[15px] bg-[#EFBD37] transition-all duration-400 ease-[cubic-bezier(0.645,0.045,0.355,1)] border border-[#fff] border-solid hover:bg-[rgba(0,0,0,0.55)] hover:text-white"
            >
              Sponsor a Project
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
